import React from 'react';
import { ImageCard } from '@beef/smart-kit';
import { Link, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { CardText } from "../CardText";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var ArticleCard = function ArticleCard(_ref) {
  var href = _ref.href,
    image = _ref.image,
    text = _ref.text,
    readTime = _ref.readTime,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(Link, {
    className: cx('wrapper'),
    href: href,
    "data-t-id": "ArticlesBlock-ArticleCard"
  }, /*#__PURE__*/React.createElement(ImageCard, {
    bordered: true,
    classes: {
      common: cx('image-card')
    },
    img: image,
    size: "l",
    text: /*#__PURE__*/React.createElement(CardText, {
      text: text,
      time: readTime
    }),
    title: /*#__PURE__*/React.createElement(Text, {
      className: cx('title'),
      size: "size4-m",
      tagType: "h6"
    }, title),
    "data-t-id": "ArticlesBlock-ArticleCard"
  }));
};